// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/DespesasStatus_CreateInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/despesas_status/create
 *
 * Creates a new expense status.
 */
import { registerContract } from './validate'

export interface DespesasStatus_CreateInput {
despesa_status_titulo: string
}

registerContract('DespesasStatus_CreateInput', {
  despesa_status_titulo: { type: 'string',  required: true },
})
